export default __webpack_public_path__ + "static/media/wo.c36da9bd.jpg";